import Design_system from './Template'

export default Design_system
